<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: null,
                    },
                ]"
            />
        </template>

        <div v-if="meta.links.show" class="flex justify-end">
            <InertiaSquareLinkButton action="show" :href="meta.links.show" />
        </div>

        <NavLinks :links="meta.links.adaptations" class="mt-1" />

        <QuizForm :activity="activity" :questions="questions" :options="options" :meta="meta" />
    </PanelPage>
</template>

<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import QuizForm from '@/Pages/Teacher/Quiz/Activity/Preview/QuizForm.vue';
import NavLinks from '@/components/NavLinks.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';

export default {
    components: {
        InertiaSquareLinkButton,
        NavLinks,
        QuizForm,
        PanelPage,
    },
    layout: LandingLayout,
    name: 'Create',
    props: ['meta', 'options', 'questions', 'activity'],
};
</script>
